import {MEDIA_TYPES} from 'constants/dance'

const colors = {
    WHITE: '#fff',
    APP_WHITE: '#fefefe',
    APP_BLACK: '#000',
    APP_BLACK_LIGHT: '#333333',
    APP_GRAY: '#ccc',
    APP_GRAY_LIGHT: '#F6F4F1',
    APP_GRAY_DARK: '#aaa',

    PRIMARY_COLOR: 'blue',
    PRIMARY_TEXT: '#45484b',
    ERROR_TEXT: 'red',
    BACKGROUND_GREY: '#A0A6AB',
    GREY_WHITE: '#e8e8e8',
    TORQUISE: '#4ABCC1',
    BLUE: '#7399fb',
    OPAC_BLUE: 'rgba(90, 132, 255, 0.24)',
    OPAC_RED: 'rgba(255, 0, 0, 0.24)',
    DARK_BLUE: '#5A84FF',
    SIDEBAR_BACKGROUND: '#28231D',

    TABLE_WHITE: '#f8f8f8',
    VIDEO: '#4ABCC1',
    SONG: '#7399fb',
}

export const getTabColor = (type, isActive) => {
    if (!isActive) {
        return colors.APP_WHITE
    }
    if (type === MEDIA_TYPES.video) {
        return colors.TORQUISE
    }
    return colors.BLUE
}
export default colors
